import { render } from "./grouppagebuilderusers.vue?vue&type=template&id=1ec9552b&ts=true"
import script from "./grouppagebuilderusers.vue?vue&type=script&lang=ts"
export * from "./grouppagebuilderusers.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__